import { AppHeader } from '../components/AppHeader';

export function HelpScreen({ onBack }: { onBack: () => void }) {
  const steps = [
    { icon: '🧱', title: '1. Set the scene', text: 'Put your toys or drawings where you want them.' },
    { icon: '📷', title: '2. Take a picture', text: 'Keep the camera still and tap the big picture button.' },
    { icon: '☝️', title: '3. Move a tiny bit', text: 'Move one thing just a little, then take another picture.' },
    { icon: '▶️', title: '4. Play your movie', text: 'Take lots of pictures, then press Play!' },
  ];
  return (
    <div className="screen-shell">
      <AppHeader title="How to Make a Movie" onBack={onBack} backLabel="Back to home" />
      <main className="help-screen">
        <p className="help-intro">Four easy steps. You’ve got this!</p>
        <ol className="help-steps">
          {steps.map((step) => (
            <li key={step.title}>
              <span className="step-icon" aria-hidden="true">{step.icon}</span>
              <div><h2>{step.title}</h2><p>{step.text}</p></div>
            </li>
          ))}
        </ol>
        <button className="button primary big-button" type="button" onClick={onBack}>Got it!</button>
      </main>
    </div>
  );
}

